export enum FundRaiserStatus {
  ACTIVE = 0,
  FULLY_FUNDED = 1,
  REPAYING = 2,
  REPAID = 3,
  CLOSED = 4,
}
